import React from 'react';
import { observer } from 'mobx-react';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router';
import { Card, CardContent } from '@components/ui/card';
import { MSLogo } from '../components/svg-icons/ms-logo';
import { injectTSDI } from '../core/tsdi';
import { Api } from '../core/api';
import { links } from '../core/router';

export const Login = observer(() => {
    const { addPermission, removePermission, exchangeGoogleCredential } =
        injectTSDI(Api);
    const navigate = useNavigate();

    const handleSuccess = async (response: CredentialResponse) => {
        if (response.credential === undefined) {
            return;
        }
        try {
            await exchangeGoogleCredential(response.credential);
        } catch (error) {
            console.log('Login Failed', error);
            removePermission('LOGGED_IN');
            return;
        }
        addPermission('LOGGED_IN');
        navigate(links.tenants());
    };

    return (
        <div className="flex min-h-screen items-center justify-center p-4">
            <Card className="w-full max-w-sm">
                <CardContent className="flex flex-col items-center gap-6">
                    <div className="flex flex-col items-center gap-2">
                        <MSLogo className="size-24 text-primary" />
                        <h1 className="text-lg font-bold tracking-tight">
                            Move Republic Admin
                        </h1>
                    </div>

                    <GoogleLogin
                        onSuccess={handleSuccess}
                        onError={() => {
                            console.log('Login Failed');
                            removePermission('LOGGED_IN');
                        }}
                        useOneTap
                        auto_select
                        itp_support
                        // FedCM has 10-minute rate limit for auto re-auth - disable for local dev
                        use_fedcm_for_prompt={
                            process.env.NODE_ENV === 'production'
                        }
                        use_fedcm_for_button={
                            process.env.NODE_ENV === 'production'
                        }
                    />
                </CardContent>
            </Card>
        </div>
    );
});
